import { SignUp } from '@clerk/clerk-react'
import {CenteredElement} from "../components/CenteredElement";

export const SignUpPage = () => <CenteredElement><SignUp path="/sign-up"/></CenteredElement>